
export const locale = {
  lang: "ru",
  data: {
    "ButtonTitle": "OK",
  }
};
